function hasClass(element, className) {
  if (element.classList)
    return !!className && element.classList.contains(className);
  return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}
export {
  hasClass as default
};
//# sourceMappingURL=hasClass.es.js.map
